//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Models

import { Enums } from '../../../../models/common'
import { OpDescr } from '../../../../../app/models/core'
import { Dictionary } from '../../../../../app/helpers'
import { IReferenceType } from '../../../../../app/models/util/interfaces'

//#endregion

//#region Service Imports

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

//#endregion

// #region Consts

export const PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_NAME: string = 'PecGliwiceDataTypeGroupCreateEditFormService'
export const PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_PROVIDER_NAME: string = 'PecGliwiceDataTypeGroupCreateEditFormServiceProvider'

// #endregion

export class PecGliwiceDataTypeGroupCreateEditFormService {

    // #region Consts    

   

    // #endregion

    // #region Ctor

    public constructor(private readonly userSession: UserSessionService) { }

    // #endregion

    // #region Options    
}



export class PecGliwiceDataTypeGroupCreateEditFormServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSession: UserSessionService) {
        return new PecGliwiceDataTypeGroupCreateEditFormService(userSession)
    }]

    // #endregion
} 